import React, { createContext, ReactElement, ReactNode, useContext, useEffect } from 'react';

const PageHeaderOverrideContext = createContext<((override: string | undefined) => void) | undefined>(undefined);

export function PageHeaderOverrideProvider({
  setHeaderOverride,
  children,
}: {
  setHeaderOverride: (override: string | undefined) => void;
  children: ReactNode;
}): ReactElement {
  return (
    <PageHeaderOverrideContext.Provider value={setHeaderOverride}>
      {children}
    </PageHeaderOverrideContext.Provider>
  );
}

/**
 * Lets a page override the top-level route-based header (see `routeToHeader` in App.tsx)
 * with page-specific content, e.g. appending an entity name. The override is cleared
 * automatically when the calling component unmounts.
 */
export function usePageHeaderOverride(override: string | undefined): void {
  const setHeaderOverride = useContext(PageHeaderOverrideContext);

  useEffect(() => {
    if (!setHeaderOverride) {
      return;
    }

    setHeaderOverride(override);

    return () => setHeaderOverride(undefined);
  }, [override, setHeaderOverride]);
}
